import { render } from "./SignUpView.vue?vue&type=template&id=a9f380d8"
import script from "./SignUpView.vue?vue&type=script&lang=js"
export * from "./SignUpView.vue?vue&type=script&lang=js"

import "./SignUpView.vue?vue&type=style&index=0&id=a9f380d8&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__